document.addEventListener('DOMContentLoaded', function () {
  // nespusti se vubec na mobilu (preload obrazku - zpomaluje)
  // kontroluje, zda se zvetsilo okno a pokud ano, nacte se
  const desktopQuery = window.matchMedia("(min-width: 768px)");
  let menuInitialized = false;

  function initMegaMenu() {

    if (menuInitialized) return;
    if (!desktopQuery.matches) return;

    menuInitialized = true;

    // ===== původní kód začíná tady =====

    function waitForJsonElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const interval = 100;
        const start = Date.now();

        const check = () => {
          const el = document.querySelector(selector);
          if (el) return resolve(el);
          if (Date.now() - start >= timeout) return reject(new Error('⛔ JSON <script> nenalezen'));
          setTimeout(check, interval);
        };
        check();
      });
    }

    waitForJsonElement('#menu-data', 8000)
    .then(menuDataEl => {
      let menuJson;
      try {
        menuJson = JSON.parse(menuDataEl.textContent);
      } catch (e) {
        console.error('❌ Chyba při parsování JSON:', e);
        return;
      }

      const menuItems = menuJson.menu;
      if (!Array.isArray(menuItems) || !menuItems.length) {
        console.warn('⚠️ Žádná položka menu ve `menuJson.menu`');
        return;
      }

      const replayMenu = document.createElement('div');
      replayMenu.className = 'replay-megamenu-root header__nav';

      const topUl = document.createElement('ul');
      topUl.className = 'replay-top-level';

      /*const imgMap = {
        'Muži|Džíny': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/01-600x243.jpg',
        'Muži|Oblečení': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/02-600x243.jpg',
        'Muži|Doplňky': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/03-600x243.jpg',
        'Muži|Obuv': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/04-600x243.jpg',
        'Muži|Projekty': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Muži|Kolekce': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Ženy|Džíny': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/06-600x243.jpg',
        'Ženy|Oblečení':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/07-600x243.jpg',
        'Ženy|Příslušenství':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/08-600x243.jpg',
        'Ženy|Kolekce':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/11-243x390.jpg'
      };*/

      const imgMap = {
        //'Nová kolekce|Muži':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Studio_Session_day_2-4776.jpg?v=1769197685',
        //'Nová kolekce|Ženy':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Studio_Session_day_2-4776.jpg?v=1769197685',

        'Muži': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_APPAREL.jpg?v=1772291440',
        'Muži|Oblečení': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_APPAREL.jpg?v=1772291440',
        'Muži|Džíny': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_JEANS.jpg?v=1772291440',
        'Muži|Boty': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_SHOES.jpg?v=1772291440',
        'Muži|Doplňky': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_ACCESSORIES.jpg?v=1772291440',
        //'Muži|Projekty': 'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/05-600x243.jpg',
        'Muži|Projekty': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_APPAREL.jpg?v=1772291440',

        'Ženy': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_APPAREL.jpg?v=1772291440',
        'Ženy|Oblečení':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_APPAREL.jpg?v=1772291440',
        'Ženy|Džíny':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_JEANS.jpg?v=1772291441',
        'Ženy|Boty':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_SHOES.jpg?v=1772291440',
        'Ženy|Doplňky':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_ACCESSORIES.jpg?v=1772291440',
        //'Ženy|Projekty':'https://replayjeans.kleecks-cdn.com/gb/media/wysiwyg/SS25/SWITCH/11-243x390.jpg',
        'Ženy|Projekty': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_APPAREL.jpg?v=1772291440',

        'Džíny': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_JEANS.jpg?v=1772291440',
        'Džíny|Průvodce velikostí': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_JEANS.jpg?v=1772291440',
        'Džíny|Muži': 'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_MEN_JEANS.jpg?v=1772291440',
        'Džíny|Ženy':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/mega_menu_WOMEN_JEANS.jpg?v=1772291441',

        'Výprodej':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Season-sale-50_hero-desktop-1.png?v=1766565897',
        'Výprodej|Muži':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Season-sale-50_hero-desktop-1.png?v=1766565897',
        'Výprodej|Ženy':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/Season-sale-50_hero-desktop-1.png?v=1766565897',

        'Vouchery':'https://cdn.shopify.com/s/files/1/0816/4199/6631/files/megamenu-voucher-ss26.jpg?v=1772294361',
      };

      //to prevent flickering when hovering for the first time
      function preloadMenuImages(map) {
        const loaded = {};

        Object.values(map).forEach(src => {
          if (!src || loaded[src]) return;

          const img = new Image();
          img.src = src;

          loaded[src] = true;
        });

        console.log('🖼️ Mega menu images preloaded');
      }

      preloadMenuImages(imgMap);

      function createMenuItem(title, url) {
        const a = document.createElement('a');
        a.href = url || '#';
        a.textContent = title;
        return a;
      }

      function createThirdLevel(thirdItems) {
        const wrapper = document.createElement('div');
        wrapper.className = 'replay-third-panel';

        const ul = document.createElement('ul');

        if (Array.isArray(thirdItems)) {
          thirdItems.forEach(item => {
            const li = document.createElement('li');
            li.appendChild(createMenuItem(item.title, item.url));
            ul.appendChild(li);
          });
        }

        wrapper.appendChild(ul);
        return wrapper;
      }

      menuItems.forEach(topItem => {
        const topLi = document.createElement('li');
        topLi.className = 'replay-menu-item';





        // seznam odkazů, které mají být jen na mobilu
        const hiddenOnDesktop = [
          '/pages/denim-fit-guide-ss26',
          '/pages/prodejny',
          '/pages/faq',
          '/policies/terms-of-service',
          '/policies/contact-information',
          '/pages/vernostni-sleva',
          '/pages/replay-world',
          '/#old',
          '#o-replay'
        ];

        if (hiddenOnDesktop.includes(topItem.url)) {
          topLi.style.display = "none"; // hned schovat
          topLi.classList.add("mobile-only"); // pro přepis v CSS na mobilech
          topLi.classList.add('mobile-only');
        }





        topLi.appendChild(createMenuItem(topItem.title, topItem.url));

        if (Array.isArray(topItem.children) && topItem.children.length > 0) {
          const submenuWrapper = document.createElement('div');
          submenuWrapper.className = 'replay-submenu';

          const submenuUl = document.createElement('ul');
          submenuUl.className = 'replay-submenu-links';

          const imgDiv = document.createElement('div');
          imgDiv.className = 'submenu-image';

          const firstChild = topItem.children[0];
          const imgKey = `${topItem.title}|${firstChild.title}`;
          const imgSrc = imgMap[topItem.title];

          const menuImg = document.createElement('img');
          menuImg.className = 'submenu-main-image';
          menuImg.alt = topItem.title;

          if (imgSrc) {
            menuImg.src = imgSrc;
          }

          imgDiv.appendChild(menuImg);

          topItem.children.forEach(subItem => {

            const column = document.createElement('div');
            column.className = 'replay-column';

            const title = document.createElement('a');
            title.href = subItem.url || '#';
            title.textContent = subItem.title;
            title.className = 'replay-column-title';

            column.appendChild(title);

            // === HOVER → ZMĚNA OBRÁZKU ===
            column.addEventListener('mouseenter', () => {
              const key = `${topItem.title}|${subItem.title}`;
              const hoverImg = imgMap[key];

              if (!hoverImg) return;
              if (menuImg.src === hoverImg) return;

              menuImg.classList.add('is-changing');

              menuImg.onload = () => {
                menuImg.classList.remove('is-changing');
              };

              menuImg.src = hoverImg;
              menuImg.alt = subItem.title;

            });

            // children links
            if (Array.isArray(subItem.children)) {
              const ul = document.createElement('ul');

              subItem.children.forEach(child => {
                const li = document.createElement('li');
                li.appendChild(createMenuItem(child.title, child.url));
                ul.appendChild(li);
              });

              column.appendChild(ul);
            }

            submenuUl.appendChild(column);
          });

          submenuWrapper.appendChild(submenuUl);
          submenuWrapper.appendChild(imgDiv);

          topLi.appendChild(submenuWrapper);
        }

        topUl.appendChild(topLi);
      });

      replayMenu.appendChild(topUl);

      const oldNav = document.querySelector('.header__nav');
      if (oldNav) oldNav.replaceWith(replayMenu);
      else document.body.appendChild(replayMenu);

      console.log('%c✅ Menu úspěšně vygenerováno z JSON!', 'color: green; font-weight: bold');

      // === Delay pro submenu (aby hned nemizelo) ===
      document.querySelectorAll('.replay-menu-item').forEach(item => {
        let hideTimeout;

        item.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout);
          item.classList.add('open');
        });

        item.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            item.classList.remove('open');
          }, 300); // nastav si delay v ms (200–400 je ideál)
        });
      });

      // === Zvýraznění aktivní položky podle URL ===
      (function highlightActiveLinks() {
        const currentPath = window.location.pathname.replace(/\/$/, ""); 
        const links = document.querySelectorAll('.replay-megamenu-root a');

        links.forEach(link => {
          let linkPath = link.getAttribute('href');
          if (!linkPath) return;

          linkPath = linkPath.split("?")[0].replace(/\/$/, "");

          if (linkPath === currentPath) {
            // aktivovat samotný link
            link.classList.add("active");

            // projít všechny rodiče až k top-level
            let el = link.parentElement;
            while (el && !el.classList.contains('replay-megamenu-root')) {
              if (el.tagName === 'LI') {
                const a = el.querySelector('a');
                if (a) a.classList.add('active');
              }
              el = el.parentElement;
            }
          }
        });
      })();



    })
    .catch(err => {
      console.error('❌ Menu data nebyla nalezena nebo se načetla příliš pozdě:', err);
    });
  }
    
  // první load
  initMegaMenu();

  // když se okno zvětší na desktop
  desktopQuery.addEventListener("change", function(e) {
    if (e.matches) {
      initMegaMenu();
    }
  });
});